<template>
  <div class="actress-rating-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-input placeholder="请输入女优" size="small" class="param-input" v-model="params.id"></el-input>
      <el-date-picker v-model="time" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" size="small" ></el-date-picker>
      <el-button type="primary" size="small">搜索</el-button>
    </div>
    <!-- 表格数据 -->
    <el-table :data="tableDate"  style="width: 100%" border  v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <el-table-column prop="" label="女优" align="center" fixed></el-table-column>
      <el-table-column prop="name" label="照片" align="center">
        <template slot-scope="scope">
          <img-load :width="'60px'" :height="'80px'" :src="imgUrl + scope.row.cover"></img-load>
        </template>
      </el-table-column>
      <el-table-column prop="" label="评分" align="center"></el-table-column>
      <el-table-column prop="" label="评分次数" align="center" sortable></el-table-column>
      <el-table-column prop="" label="最后一次评分时间" align="center" sortable>
        <template slot-scope="scope">
          {{scope.row.startTime | changeDate}}
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[10, 15, 20, 25]" :current-page="params.pageNumber" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" background v-if="total > 10" @size-change="changeSize" @current-change="changeCurrent"></el-pagination>
  </div>
</template>
<script>
import API from '@/api'
import baseConfig from '@/utils/serverUrlConfig'
export default {
  data() {
    return {
      loading: false,
      tableDate: [1],
      total: 0,
      time: '',
      params: {
        id: '',
        pageNumber: 1,
        pageSize: 10,
        enable: ''
      },
      imgUrl: baseConfig.imgUrl,
    }
  },
  created() {
    // this.getRankList()
  },
  methods: {
    // 请求排行列表数据
    getRankList() {
      this.loading = true
      API.getRankList(this.params).then(res => {
        if (res.code === 200 && res.data) {
          this.tableData = res.data
          this.total = res.data.total
        } else {
          this.tableData = []
          this.total = 0
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 编辑弹窗
    addAction(type,data){
      this.$refs.filmPopups.open(type,data)
    },
     // 监听编辑成功过后重新拉去数据
    handlerRankList() {
      this.param.pageNumber = 1
      this.param.pageSize = 10
      this.getRankList()
    },
    // 编辑排行弹窗
     editToday(type,row) {
      this.$refs.editToday.open(type,row)
    },
    // 分页条数改变回掉
    changeSize(size) {
      this.params.pageSize = size
      this.getRankList()
    },
    // 分页页码改变回掉
    changeCurrent(number) {
      this.params.pageNumber = number
      this.getRankList()
    },
  }
}
</script>
